export class Stage {
    stageId:string;
    projectId:string;
    projectname:string;
    title:string;
    description?:string;
    startdate?:string;
    enddate?:string;
    creator?:string;
    created?:string;
    versioncreator?:string;
    validfrom?:string;
    validto?:string;
    stagevisibility?:string = 'Shared';
    organizationId:string;
    organizationname:string;
    orgdesc:string;
    orgemail:string;
    orgwww:string;
    orglogourl:string;
    customer:string;
    customername:string;
}
